import axios from 'axios';
import BaseAPI from './base/base-api';

class InvoiceTrialAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotTrialsAPI';
    controllerName = 'invoices';
}

export default new InvoiceTrialAPI();